import {gql} from 'apollo-boost'

export const mOdeslatPoptavku = gql`
  mutation OdeslatPoptavku($poptavka: Poptavka!) {
    odeslatPoptavku(
      poptavka: $poptavka
    )
  }
`;
